import type { FormKitNode } from '@formkit/core'

const isBrowser = typeof window !== 'undefined'

function removeHover(e: Event) {
  if (
    e.target instanceof HTMLElement &&
    e.target.hasAttribute('data-file-hover')
  ) {
    e.target.removeAttribute('data-file-hover')
  }
}

function preventStrayDrop(type: string, e: Event) {
  if (!(e.target instanceof HTMLInputElement)) {
    e.preventDefault()
  } else if (type === 'dragover') {
    e.target.setAttribute('data-file-hover', 'true')
  }
  if (type === 'drop') {
    removeHover(e)
  }
}

export default function (node: FormKitNode): void {
  node.addProps(['_hasMultipleFiles'])

  if (isBrowser) {
    if (!window._FormKit_File_Drop) {
      window.addEventListener(
        'dragover',
        preventStrayDrop.bind(null, 'dragover')
      )
      window.addEventListener('drop', preventStrayDrop.bind(null, 'drop'))
      window.addEventListener('dragleave', removeHover)
      window._FormKit_File_Drop = true
    }
  }
  node.hook.input((value, next) => next(Array.isArray(value) ? value : []))
  node.on('input', ({ payload: value }) => {
    node.props._hasMultipleFiles =
      Array.isArray(value) && value.length > 1 ? true : undefined
  })

  node.on('reset', () => {
    if (node.props.id && isBrowser) {
      const el = document.getElementById(node.props.id)
      if (el) (el as HTMLInputElement).value = ''
    }
  })

  node.on('created', () => {
    if (!Array.isArray(node.value)) node.input([], false)

    if (!node.context) return

    node.context.handlers.resetFiles = (e: Event) => {
      e.preventDefault()
      node.input([])
      if (node.props.id && isBrowser) {
        const el = document.getElementById(node.props.id)
        if (el) (el as HTMLInputElement).value = ''
        el?.focus()
      }
    }

    node.context.handlers.files = (e: Event) => {
      const files: Array<File> = []
      if (e.target instanceof HTMLInputElement && e.target.files) {
        for (let i = 0; i < e.target.files.length; i++) {
          const file = e.target.files.item(i)
          if (file) {
            files.push(file)
          }
        }
        node.input(files)
      }
      if (node.context) node.context.files = files

      if (typeof node.props.attrs?.onChange === 'function') {
        node.props.attrs?.onChange(e)
      }
    }

    node.context.handlers.removeFile = (f: File) => (e: Event) => {
      e.preventDefault()
      const files = (node.value as Array<File>).filter(file => f !== file)
      node.input(files)

      if (node.props.id && isBrowser) {
        const el = document.getElementById(node.props.id)
        if (el) (el as HTMLInputElement).files = files.reduce((fileList: DataTransfer, file: File) => {
          fileList.items.add(file)
          return fileList
        }, new DataTransfer()).files
      }
    }

    node.context.fns.getPreviewUrl = (file: File) => {
      if (file instanceof File) {
        return URL.createObjectURL(file)
      }

      return false
    }
  })
}